import { userService } from "@/app/api/user";
import type { AnalyticsPageData } from "@/types/analytics-page";
import type { DataDumpResponse } from "@/types/api";
import type {
  CreateSubscriptionInput,
  PortfolioResponse,
  Subscription,
  UpdateSubscriptionInput,
  UsageResponse,
} from "@/types/usage";

export const getPageInformation = async (
  companyId: string,
  datadump: string,
): Promise<DataDumpResponse> => {
  try {
    const response = await userService.axiosWithUserAuth.post<DataDumpResponse>(
      "/screener/ats/data-dump",
      {
        companyId,
        datadump,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching candidate data:", error);
    throw error;
  }
};

export const getScreenerAnalytics = async () => {
  try {
    const response =
      await userService.axiosWithUserAuth.get<AnalyticsPageData>("/analytics");
    return response.data;
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
};

export const getUsage = async () => {
  try {
    const response =
      await userService.axiosWithUserAuth.get<UsageResponse>(
        "/analytics/usage",
      );
    return response.data;
  } catch (error) {
    console.error("Error fetching usage:", error);
    throw error;
  }
};

export const getUsagePortfolio = async () => {
  try {
    const response = await userService.axiosWithUserAuth.get<PortfolioResponse>(
      "/analytics/portfolio",
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching usage portfolio:", error);
    throw error;
  }
};

export const getCompanySubscriptions = async (companyId: string) => {
  try {
    const response = await userService.axiosWithUserAuth.get<Subscription[]>(
      `/subscriptions/company/${companyId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company subscriptions:", error);
    throw error;
  }
};

export const createSubscription = async (input: CreateSubscriptionInput) => {
  try {
    const response = await userService.axiosWithUserAuth.post<Subscription>(
      "/subscriptions",
      input,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating subscription:", error);
    throw error;
  }
};

export const updateSubscription = async (
  id: string,
  input: UpdateSubscriptionInput,
) => {
  try {
    const response = await userService.axiosWithUserAuth.patch<Subscription>(
      `/subscriptions/${id}`,
      input,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating subscription:", error);
    throw error;
  }
};
